import { ClaimDocumentType } from 'app/claims/models/claim-document-type.enum';
import { ClaimType } from 'app/claims/models/claim-type.enum';
import dayjs from 'dayjs';
import { Carriers, ShipmentStatus } from '../../../../shared/enum/general-enum';
import { ClaimStatus } from '../../../models/claim-status.enum';

export const FILE_CLAIM_CONFIG = {
    /**
     * Specifies the time window for filtering claims.
     *
     * @property {number} number - The numeric value for the time window (e.g., 6 for "6 months").
     * @property {UnitType} unit - The time unit for the filter (compatible with dayjs).
     */
    timeWindow: {
        number: 6,
        unit: 'months' as dayjs.ManipulateType,
    },
    lowInsuredValueThreshold: 100,
    allowedWebShipmentCarriers: [
        Carriers.Ups,
        Carriers.Fedex,
    ],
    // claimableTrackingStatuses: [
    //     TrackingStatus.LABEL_CREATED,
    //     TrackingStatus.IN_TRANSIT,
    //     TrackingStatus.DELIVERED,
    //     TrackingStatus.EXCEPTIONS,
    // ],
    claimableShipmentStatuses: [
        ShipmentStatus.BIRNew,
        ShipmentStatus.BillingInfo,
        ShipmentStatus.Delivered,
        ShipmentStatus.Exception,
        ShipmentStatus.InTransit,
        ShipmentStatus.LabelPrinted,
        ShipmentStatus.Manifest,
        ShipmentStatus.PickupScan,
        ShipmentStatus.Reinstated,
        ShipmentStatus.ReprintRequested,
        ShipmentStatus.TNF,
        ShipmentStatus.VoidButDelivered,
        ShipmentStatus.VoidButException,
        ShipmentStatus.VoidButInTransit,
        ShipmentStatus.Voided,
    ],
    claimableClaimStatuses: [
        ClaimStatus.NEW,
        ClaimStatus.DRAFT,
        ClaimStatus.SUITABLE_FOR_CLAIM,
        ClaimStatus.INVALID_CARRIER,
        ClaimStatus.DRAFT_DISCARDED,
    ],
    claimContact: {
        maxCompanyNameLength: 50,
        maxFirstNameLength: 15,
        maxLastNameLength: 19,
        maxPhoneLength: 15,
        maxEmailLength: 60,
        maxAddress1Length: 35,
        maxAddress2Length: 35,
        maxCityLength: 35,
        maxStateLength: 35,
        maxZipLength: 10,
        maxCountryLength: 2,
    },
    claimMerchandise: {
        minQuantity: 1,
        maxQuantity: 5,
        minNumberOfItems: 1,
        minInvoiceValue: 1,
        maxInvoiceValue: 99999999.99,
        minClaimedAmount: 1,
        maxClaimedAmount: 99999999.99,
        maxDescriptionLength: 150,
        descriptionRegex: /^[\w\s\-+&()/,~`#.:;“*‘]*$/,
        maxItemNumberLength: 20,
        maxSerialNumberLength: 20,
        digitAndDecimalLimit: { maxDigits: 11, maxDecimalPoints: 2 },
    },
    claimPackaging: {
        maxOuterBoxDescriptionLength: 20,
        maxInnerBoxDescriptionLength: 20,
        maxOtherPackagingDescriptionLength: 20,
    },
    claimAdditionalInformation: {
        maxDetailsLength: 255,
    },
    claimFileUpload: {
        isImmediateUpload: true,
        maxFileSizeMB: 5,
        maxNumberOfFiles: 10,
        // allowedFileTypes: ['.pdf', '.jpg', '.jpeg', '.png', '.gif', '.doc', '.docx', '.xls', '.xlsx', '.txt'],
        allowedFileTypes: ['.jpg', '.pdf', '.docx', '.xls'],
        allowedPhotoFileTypes: ['.jpg', '.pdf'],
        maxRetries: 0,
        maxParallelUploads: 5,
        claimDocumentMap: {
            [ClaimType.LOST]: [
                ClaimDocumentType.INVOICE,
                ClaimDocumentType.OTHER,
            ],
            [ClaimType.DAMAGED]: [
                ClaimDocumentType.INVOICE,
                ClaimDocumentType.REPAIR_ESTIMATE,
                ClaimDocumentType.PHOTOGRAPH,
                ClaimDocumentType.OTHER,
                ClaimDocumentType.SHIPPING_LABEL,
                ClaimDocumentType.BOX_TOP,
                ClaimDocumentType.BOX_BOTTOM,
                ClaimDocumentType.DAMAGED,
                ClaimDocumentType.PACKAGING_MATERIALS_OUTER,
                ClaimDocumentType.PACKAGING_MATERIALS_INNER,
            ],
            [ClaimType.MISSING_CONTENTS]: [
                ClaimDocumentType.INVOICE,
                ClaimDocumentType.REPAIR_ESTIMATE,
                ClaimDocumentType.PHOTOGRAPH,
                ClaimDocumentType.OTHER,
                ClaimDocumentType.SHIPPING_LABEL,
                ClaimDocumentType.BOX_TOP,
                ClaimDocumentType.BOX_BOTTOM,
                ClaimDocumentType.DAMAGED,
                ClaimDocumentType.PACKAGING_MATERIALS_OUTER,
                ClaimDocumentType.PACKAGING_MATERIALS_INNER,
            ],
        },
    },
};
